<template>
    <div name="pharmacy-detail" class="pharmacy-detail" v-if="pharmacy">
        <share-modal 
            v-if="isShareModal"
            :pharmacy="pharmacy"
            @onClose="closeShareModal"
        />
        <div class="page">
            <div class="header" >
                <div class="button-area" @click="back" v-if="isBack">
                    <img style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" />
                </div>
            </div>
            <div class="map" id="map-details" style="width: 100%;height: 155px;"></div>
            <div class="action-box">
                <div class="row-space-between">
                    <span class="pharmacy-name-text">{{pharmacy.name}}</span>
                    <div class="share-button" @click="share">
                        <img style="margin-right: 4px; width: 22px;" src="../assets/share3.png" />
                        공유
                    </div>
                </div>
                <div class="row-flex-start" style="margin-top: 16px;">
                    <div class="button1" style="margin-right: 8px;" @click="viewMaps">지도</div>
                    <div class="button2" style="margin-right: 8px;" @click="guidanceRoute(pharmacy.name, pharmacy.longitude, pharmacy.latitude)">길찾기</div>
                    <div class="button1" v-if="isMobile" @click="tel(pharmacy.phone_Number)">전화</div>
                </div>
            </div>
            <div class="pharmacy-info-box">
                <div class="row-flex-start">
                    <img style="margin-left: 3px;" src="../assets/address.png" />
                    <span style="margin-left: 8px;" class="info-text">{{ pharmacy.address }}</span>
                </div>
                <div class="row-flex-start" style="margin-top: 9px;">
                    <img src="../assets/phone.png" />
                    <span style="margin-left: 8px;" class="info-text">{{ pharmacy.phone_Number }}</span>
                </div>
            </div>
            <div class="medicine-info-box">
                <span class="medicine-info-box-title">{{ hasBaqsimi ? '취급 약품 품목' : '취급 인슐린 품목' }}</span>

                <div v-if="medicines.length > 0" class="col" style="margin-top: 20px; margin-bottom: 12px;">
                    <span v-for="(medicine, index) in medicines" class="medicine-text">{{ medicine }}</span>
                </div>
                <span v-else class="empty" style=" margin-top: 20px; margin-bottom: 20px;">약국에 직접 문의</span>

                <span class="medicine-info-box-warning">
                    <span style="color: #184FA1;">*</span>
                    인슐린 품목 및 재고, 비대면처방 조제, 팩스 번호 사전 확인이 필요합니다.
                </span>
            </div>
            <div class="footer">
                <span>
                    ⓒ soldoc. <br>
                    본 인슐린 약국 지도는 (사)한국1형당뇨병환우회와 솔닥이 공동 제작한 자료로, 저작권은 솔닥에 있습니다. 상업적 이용 및 무단 복제·배포는 금지되며, 위반 시 법적 책임이 따를 수 있습니다.
                </span>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import ShareModal from '@/components/modals/ShareModal';
import Constant from '@/constant';
import Medicine from '@/utilities/medicine';
export default {
    name: 'pharmacyDetail',
    components: {ShareModal},
    props: ['propsPharmacy'],
    computed: {
        hasBaqsimi: function()
        {
            return Medicine.hasBaqsimi(this.medicines);
        }
    },
    data: function()
    {
        return {
            pharmacy: null,
            map: null,
            medicines: [],
            isShareModal: false,
            isMobile: false,
            isBack: false
        }
    },
    mounted: async function()
    {
        console.log("[detail]: " + JSON.stringify("[detail]: " + JSON.stringify(this.propsPharmacy)))
        if(!this.isPC())
        {
            this.isMobile = true;
        }
        else
        {
            this.isMobile = false;
        }

        if(this.propsPharmacy)
        {

            this.pharmacy = this.propsPharmacy;
            this.$nextTick(() => {
                this.initMap();
            });
            this.viewMedicines(this.pharmacy.medicines)
            this.isBack = true;
        }   
        else
        {
            if(this.$route.params.pharmacyId === null || this.$route.params.pharmacyId === undefined || this.$route.params.pharmacyId === "")
            {
                alert("잘못된 접근입니다.")
            }
            else
            {
                await this.fetchPharmacyDetail(this.$route.params.pharmacyId);
                this.initMap();
                this.viewMedicines(this.pharmacy.medicines);
                this.isBack = false;
            }
            
        }
        // alert(this.$route.params.pharmacyId)
        // 약국의 개별정보를 받아오는 API 필요함 
        // props가 없는경우 
        ///diabetes/pharmacy/detail/{pharmacyId}
    },
    methods: {
        isPC:function () {
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobile = /iphone|ipod|android|blackberry|windows phone|opera mini|iemobile|mobile/i.test(userAgent);
            return !isMobile;
        },
        initMap: async function()
        {
            this.map = new naver.maps.Map("map-details", {
                zoom: 18,  
                center: new naver.maps.LatLng(this.pharmacy.latitude, this.pharmacy.longitude),
                disableKineticPan: true, // 터치 관성 스크롤 비활성화
                draggable: false,        // 드래그 금지
                pinchZoom: false,        // 핀치줌 (모바일) 비활성화
                scrollWheel: false,      // 마우스휠 줌 비활성화
                disableDoubleClickZoom: true, // 더블클릭 줌 비활성화
                keyboardShortcuts: false,     // 키보드로 조작 비활성화
                scaleControl: false,          // 축척 컨트롤 제거
                zoomControl: false,           // 줌 컨트롤 제거
                mapDataControl: false         // 맵 데이터 표시 버튼 제거
            });

            //marker
            const latlng = new naver.maps.LatLng(this.pharmacy.latitude, this.pharmacy.longitude);
        
            const marker = new naver.maps.Marker({
                position: latlng,
                map: this.map,
                icon: {
                    content: `        
                        <div style="position: relative; display: inline-block;">
                        <!-- 말풍선 본체 -->
                        <div style="
                            background: #1a1a1a;
                            height: 37px;
                            border-radius: 16px;
                            color: var(--Gray-primary-color2, #FFF);
                            font-family: Pretendard;
                            font-size: 14px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 20px; /* 142.857% */
                            display: inline-block;
                            box-sizing: border-box;
                            width: 110.5px;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            z-index: 1000; 
                        ">
                            💉 ${this.pharmacy.name.length > 5 ? this.pharmacy.name.substring(0, 5) + "..." : this.pharmacy.name}
                        </div>

                        <!-- 꼬리 삼각형 -->
                        <div style="
                            position: absolute;
                            bottom: -8px;
                            left: 15%;
                            transform: translateX(-15%);
                            width: 0;
                            height: 0;
                            border-left: 6px solid transparent;
                            border-right: 6px solid transparent;
                            border-top: 8px solid #1a1a1a;
                            z-index: 1000; 
                        "></div>
                    </div>`,
                    size: new naver.maps.Size(29, 29), // 이미지 크기
                    scaledSize: new naver.maps.Size(29, 29),
                    origin: new naver.maps.Point(0, 0), // 이미지 원점
                    anchor: new naver.maps.Point(14.5, 29) // 마커 기준 위치 (하단 중앙 기준이면 이렇게)
                }
            });
        },
        fetchPharmacyDetail: async function(pharmacyId)
        {
            this.pharmacy = null;
            const url = `${process.env.API_DB_ROOT}/diabetes/pharmacy/detail/${pharmacyId}`;
            const response = await axios.get(url);  
            this.pharmacy = response.data.data;
        },
        viewMedicines: function(data)
        {
            if(data !== null  || data !== '')
            {
                this.medicines = [];
                const dd = data.split(", ");
                dd.forEach(element => {
                    if(element !== '확인필요')
                    {
                        this.medicines.push(element)
                    }
                   
                });
            }

        },
        back: function()
        {
            // map, list일때 다르게 동작
            this.$emit('onClose')
        },
        share: function()
        {
            this.isShareModal = true;
        },
        closeShareModal: function()
        {
            this.isShareModal = false;
        },
        guidanceRoute: function(name, longitude, latitude)
        {
            window.open(`https://m.map.naver.com/route.nhn?menu=route&ename=${name}&ex=${longitude}&ey=${latitude}&pathType=0&showMap=true`, '_blank')
        },
        tel: function(phone)
        {
            window.location.href = `tel:${phone}`;
        },
        viewMaps: function()
        {
            if(!this.isBack)
            {
                this.$store.commit(Constant.SET_SHARED_PHARMACY, {
                    pharmacy: this.pharmacy
                })
                
                this.$router.push({path:'/pharmacy-map'})
            }
            else
            {
                this.$emit('viewMaps', this.pharmacy)
            }   

           
            // this.$emit('viewMaps', this.pharmacy)
        },
        kakaoShare: function()
        {
            const address = this.pharmacy.address.split(" ");
            let address2 = "";
            if(address.length > 1)
            {
                address2 = `${address[0]} ${address[1]}`
            }
            else
            {
                address2 = this.pharmacy.address
            }

            let medicines2 = "";

            if(this.medicines.length > 1)
            {
                medicines2 = `- ${this.medicines[0]}, ${this.medicines[1]} 등 취급`
            }
            else if (this.medicines.length === 1)
            {
                medicines2 = `- ${this.medicines[0]} 취급`
            }
            else 
            {
                medicines2 = "";
            }

            this.isShareModal = false;
            Kakao.Share.sendDefault({
                objectType: 'text',
                text: `[전국 인슐린 약국 지도]\n솔닥x한국1형당뇨병환우회가 함께 만들었어요!\n주변에 인슐린이 필요한 분이 있다면 공유해주세요.\n${address2} ‘${this.pharmacy.name}’ ${medicines2}`,
                link: {
                    mobileWebUrl: `${process.env.LOGIN_URI}/detail/${this.pharmacy.index}`,
                    webUrl: `${process.env.LOGIN_URI}/detail/${this.pharmacy.index}`,
                },
            });
        },
        copyLink: function()
        {
            this.isShareModal = false;

            const address = this.pharmacy.address.split(" ");
            let address2 = "";
            if(address.length > 1)
            {
                address2 = `${address[0]} ${address[1]}`
            }
            else
            {
                address2 = this.pharmacy.address
            }

            let medicines2 = "";

            if(this.medicines.length > 1)
            {
                medicines2 = `- ${this.medicines[0]}, ${this.medicines[1]} 등 취급`
            }
            else if (this.medicines.length === 1)
            {
                medicines2 = `- ${this.medicines[0]} 취급`
            }
            else 
            {
                medicines2 = "";
            }

            this.isShareModal = false;
            let text = `[전국 인슐린 약국 지도]\n솔닥x한국1형당뇨병환우회가 함께 만들었어요!\n주변에 인슐린이 필요한 분이 있다면 공유해주세요.\n${address2} ‘${this.pharmacy.name}’ ${medicines2}\n${process.env.LOGIN_URI}/detail/${this.pharmacy.index}`


            navigator.clipboard.writeText(text)
                .then(() => {
                    console.log("클립보드에 복사되었습니다:");
                    alert("URL이 복사되었습니다.\n원하는 곳에 붙여넣기 해주세요.")
                })
                .catch(err => {
                    console.error("복사 실패:", err);
                });
        }
    }
}
</script>

<style scoped>
    .pharmacy-detail {
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: flex-start;
    }

    .page {
        display: flex;
        width: 100%;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
        }
    }
      

    .header {
        width: 100%;
        height: 49px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 15.5px;
        box-sizing: border-box;
    }
    .button-area {
        width: 50px;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        cursor: pointer;
    }
    .action-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 20px 16px;
        border-radius: 20px 20px 0 0;
        margin-top: -10px;
        border-bottom: 1px solid #D1D6DB;
        background: #FFF;
        z-index: 1;
    }
    .row-space-between {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .share-button {
        box-sizing: border-box;
        height: 32px;
        border-radius: 100px;
        background: var(--Gray-20, #F3F5F8);
        display: flex;
        justify-content: center;
        align-items: center;
        border: none;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        cursor: pointer;
        width: 74px;
    }

    .pharmacy-info-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20px 16px;
        box-sizing: border-box;

    }
    .pharmacy-name-text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        width: 207px;
    }
    .row-flex-start {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
    .button1 {
        width: 64px;
        height: 34px;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFF;
        cursor: pointer;
    }
    .button2 {
        width: 79px;
        height: 34px;
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: 18px; /* 100% */
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFF;
        cursor: pointer;
    }
    .info-text {
        color: #6B7684;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .medicine-info-box {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #E8EAEE;
    }
    .footer {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        width: 100%;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px 16px;
        box-sizing: border-box;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 16px; /* 114.286% */
    }
    .medicine-info-box-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px; /* 111.111% */
    }
    .medicine-info-box-warning {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        letter-spacing: -0.36px;
    }
    .empty {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        background: var(--gray-30-stroke, #E8EAEE);
        padding: 0 4px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .medicine-text {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        background: var(--Gray-00, #FFF);
        height: 24px;
        padding: 0 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-bottom: 8px;
    }
    .col {
        display: flex;
        flex-direction: column;
        width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
    }
</style>


// WEBPACK FOOTER //
// src/page/PharmacyDetail.vue